<template>
  <TheTable :rows="rows" :columns="columns" :pagination="pagination" :loading="loading"
    @change-page="fetchData">
    <template v-slot:metaAccount="scope">
      <p>{{ scope.row.metaAccount.user.name + " " + scope.row.metaAccount.user.lastname }}</p>
    </template>
    <template v-slot:pageName="scope">
      <div class="pageName">
        <a :href="scope.row.url" target="_blank">{{ scope.row.pageName }}</a>
      </div>
      <p class="pageId">{{ scope.row.pageId }}</p>
    </template>
    <template v-slot:destination="scope">
      <div class="pageName" v-if="scope.row.department || scope.row.timeCondition">
        <i class="fas fa-briefcase" v-if="scope.row.department" />
        <i class="fas fa-clock" v-else></i>
        <p> {{ scope.row.department ? scope.row.department.name : scope.row.timeCondition.name }}</p>
      </div>
    </template>
    <template v-slot:createdAt="scope">
      <p> {{ getDate(scope.row.createdAt) }}</p>
    </template>
    <template #actions="scope">
      <el-dropdown trigger="click">
        <el-button icon="fas fa-ellipsis-h" type="text"></el-button>
        <el-dropdown-menu slot="dropdown">
          <slot name="action-buttons" v-bind:row="scope.row"></slot>
          <el-dropdown-item icon="fas fa-pencil-alt" @click.native="handleEdit(scope.row)">{{ $t("common.edit")
          }}</el-dropdown-item>
          <el-dropdown-item icon="fas fa-trash" @click.native="handleDelete(scope.row)">{{ $t("common.delete")
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </TheTable>
</template>

<script>
import TheTable from '@/components/crud/TheTable'
export default {
  data () {
    return {
      store: 'metaPages',
      loading: true,
      columns: [
        { index: 'metaAccount.name', label: this.$t('contact-me.chat-center.social-pages.account') },
        { index: 'pageName', label: this.$t('contact-me.chat-center.social-pages.pageName') },
        { index: 'destination', label: this.$t('contact-me.chat-center.social-pages.destination') },
        { index: 'metaAccount', label: this.$t('contact-me.chat-center.social-pages.added-by') },
        { index: 'createdAt', label: this.$t('contact-me.chat-center.social-pages.addAt') },
        { index: 'actions', label: '' },
      ]
    }
  },
  components: {
    TheTable
  },
  computed: {
    organizationId () {
      return this.$store.getters["contactMe/getOrganizationId"];
    },
    pagination () {
      return this.$store.getters[`${this.store}/getPagination`];
    },
    rows () {
      return this.$store.getters[`${this.store}/getData`]
    }
  },
  methods: {
    async fetchData (params = {}) {
      this.loading = true
      await this.$store.dispatch(`${this.store}/all`, { ...params, ['organization.id']: this.organizationId })
      this.loading = false
    },
    getDate (dateString) {
      return new Date(dateString).toLocaleDateString([], { hour: '2-digit', minute: '2-digit' })
    },
    handleEdit(row) {
      this.$router.push({ 
        name: 'socialPagesEdit', 
        params : {
          id : row.id + '',
          entity : row,
          ...row['edit-params']
        } 
      });
    },
    async handleDelete(row) {
      const response = await this.$confirm(this.$t('contact-me.chat-center.social-pages.are-you-sure-you-want-to-delete-the-page', { name : row.name }), 'Warning', {
        confirmButtonText: this.$t('common.yes'),
        cancelButtonText: this.$t('common.no'),
        type: 'warning'
      })

      
      if (response !== 'confirm') {
        return;
      }
      
      try {
        await this.$store.dispatch(`${this.store}/destroy`, row.id);
        this.$message.success(this.$t('contact-me.chat-center.social-pages.the-page-was-removed-successfully', { name: row.name }));
        await this.fetchData();
      } catch (error) {
        this.$message.error(this.$t('contact-me-chat-center.social-pages.there-was-a-problem-trying-to-remove-the-page'));
      }

    }
  },
  mounted () {
    this.fetchData()
  },
}
</script>